var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDepotLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    stroke: "#5EA2FF",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10039 10.786V10.286H3.60039H2.67694C2.5959 10.2495 2.53429 10.1784 2.51053 10.091C2.48244 9.98759 2.51152 9.87711 2.5868 9.80096C2.58695 9.80081 2.5871 9.80066 2.58726 9.80051L9.80054 2.58722C9.80067 2.5871 9.8008 2.58697 9.80093 2.58684C9.91773 2.47115 10.1059 2.47105 10.2228 2.58656C10.223 2.58678 10.2233 2.587 10.2235 2.58722L17.4128 9.80051C17.4128 9.80058 17.4129 9.80065 17.413 9.80073C17.4442 9.83245 17.5005 9.94112 17.5 10.1165C17.4998 10.1829 17.4916 10.2395 17.4797 10.286H16.3997H15.8997V10.786V17.1994C15.8997 17.3651 15.7654 17.4993 15.5997 17.4993H12.3999C12.2342 17.4993 12.0999 17.3651 12.0999 17.1994V13.9996C12.0999 13.2816 11.5179 12.6996 10.8 12.6996H9.20007C8.48212 12.6996 7.90012 13.2816 7.90012 13.9996V17.1994C7.90012 17.3651 7.76582 17.4993 7.60016 17.4993H4.40034C4.23468 17.4993 4.10039 17.3651 4.10039 17.1994V10.786Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDepotLine);
export default __webpack_public_path__ + "static/media/icon-depotLine.f3a9f189dcb3b049d7eb9330b6905221.svg";
export { ForwardRef as ReactComponent };